import { getIn } from 'seamless-immutable';

export const superCashback = (page, currentSku) => {
  const config = getIn(page, ['components', 'page-config'], false);

  if (!config) {
    return false;
  }

  const cashbackRate = getIn(config, ['cashbackRate'], 0);
  const cashbackValue = getIn(config, ['cashbackValue'], 0);

  const rate = getIn(currentSku, ['offers', 'result', 0, 'bestPaymentOption', 'minQuantity', 0, 'cashback', 'rate'], 0);
  const value = getIn(
    currentSku,
    ['offers', 'result', 0, 'bestPaymentOption', 'minQuantity', 0, 'cashback', 'value'],
    0
  );

  return rate >= cashbackRate || value >= cashbackValue;
};
